import { defaultStore, CONFIG } from './config';
import { defaultEnvironment } from '../translations/utils';

export const getConfig = () => {
  return CONFIG[defaultStore][defaultEnvironment];
};
